import { InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material";
import FormSection from "../../../../../Components/Forms/FormSection/form-section";
import { SectionGlobalProps } from "../settings-global";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { produce } from "immer";
import { useTranslation } from "react-i18next";
import { PlatformDcpSettings } from "../../../../../Core/Api/Types/db-platform-infos";

const SettingsGlobalSectionMisc = (props: SectionGlobalProps) => {
  const { t } = useTranslation();
  const { platformInfos, setPlatformInfos } = props;

  return (
    <FormSection title={t("common:misc")} status="todo" sx={{ mb: 2 }}>
      <InputLabel sx={{ mb: 1 }}>{t("field:label.disableArchivingOnIngest")}</InputLabel>
      <Select
        IconComponent={ExpandMoreRoundedIcon}
        value={platformInfos.archiveDisable ? "true" : "false"}
        sx={{ mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft.archiveDisable = e.target.value == "true";
            })
          )
        }
      >
        <MenuItem value={"true"}>{t("menu:item.disableIt")}</MenuItem>
        <MenuItem value={"false"}>{t("menu:item.archiveNormally")}</MenuItem>
      </Select>

      <InputLabel sx={{ mb: 1 }}>{t("field:label.watermarkingForceForRecentTitle")}</InputLabel>
      <OutlinedInput
        value={platformInfos.watermarkForceDelayDays ?? 0}
        id={"name"}
        sx={{ width: "100%", mb: 2 }}
        type="number"
        placeholder={t("field:placeholder.leaveZeroToDisable")}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.watermarkForceDelayDays = e.target?.value ? parseInt(e.target.value) : 0;
            })
          )
        }
      />

      <InputLabel sx={{ mb: 1 }}>{t("field:label.dcpLinkVersionFile")}</InputLabel>
      <Select
        IconComponent={ExpandMoreRoundedIcon}
        value={platformInfos.dcpSettings?.groupVersionFile ? "true" : "false"}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              if (!draft.dcpSettings) draft.dcpSettings = new PlatformDcpSettings();
              draft.dcpSettings.groupVersionFile = e.target.value == "true";
            })
          )
        }
      >
        <MenuItem value={"true"}>{t("common:yes")}</MenuItem>
        <MenuItem value={"false"}>{t("common:no")}</MenuItem>
      </Select>
    </FormSection>
  );
};

export default SettingsGlobalSectionMisc;
